export enum UrlParams {
	Slider = 'sl',
	Categories = 'cat',
	Characteristics = 'chr',
	Co2Label = 'co2Lbls',
	PageIndex = 'pi',
	PageSize = 'ps',
	SearchTerm = 'st',
	ShowOnlyDeleted = 'sd',
	SortOrder = 'so',
	Tags = 'tag',
}
